import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  vouchersService,
  VoucherRateUpdateResponse,
  UpdateRatesRequest,
} from '@aslanpay/portal-common-lib';

const useUpdateVoucherRates = ({
  onSuccess,
  onError,
}: UseMutationOptions<VoucherRateUpdateResponse, Error, UpdateRatesRequest>) => {
  return useMutation<VoucherRateUpdateResponse, Error, UpdateRatesRequest>(
    (payload: UpdateRatesRequest) => vouchersService.updateRates(payload),
    { onSuccess, onError }
  );
};

export default useUpdateVoucherRates;
